const axios = require('axios')
const config = require('../config').get(process.env.REACT_APP_ENVIRONMENT);

export function login({email, password}){
  return axios.post(`${config.URL}/api/management/login`,{email, password}, {withCredentials: true, credentials: 'include'})
    .then(response => {
      return {
        type: 'LOGIN',
        paylod: response.data
      }
    })
}

export function auth(){
  return axios.get(`${config.URL}/api/management/auth`, {withCredentials: true})
    .then(response => {
      return {
        type: 'AUTH',
        paylod: response.data
      }
    })
}

// export function auth(){
//   const request = axios.get(`${config.URL}/api/management/auth`)
//     .then(response => { response.data })

//     return {
//       type: 'AUTH',
//       paylod: request
//     }
// }
export function getfeedbackSpecific(){
  return axios.get(`${config.URL}/api/feedback/specific`)
    .then(response => {
      return {
        type: 'GET_FEEDBACK_SPECIFIC',
        paylod: response.data
      }
    })
}

export function getfeedbackMotivation(){
  return axios.get(`${config.URL}/api/feedback/motivation`)
    .then(response => {
      return {
        type: 'GET_FEEDBACK_MOTIVATION',
        paylod: response.data
      }
    })
}

export function addSpecificFeedback({_id,
  minor,
  text,
  speech,
  base,
  performence,
  category,oldName}){
  return axios.post(`${config.URL}/api/feedback/specific/`, {_id,
    minor,
    text,
    speech,
    base,
    performence,
    category,oldName})
    .then(response => {
      return {
        type: 'ADD_SPECIFIC_FB',
        paylod: response.data
      }
    })
}

export function addMotivationFeedback({ _id, text, speech, workout_part_label, 
  type, state, repeated, level, gender}){

    let body = { _id, text, speech, workout_part_label, 
      type, state, repeated, level, gender}

      if (workout_part_label === '' || workout_part_label === null) {
        delete body.workout_part_label
      }
  return axios.post(`${config.URL}/api/feedback/motivation/`, body)
    .then(response => {
      return {
        type: 'ADD_MOTIVATION_FB',
        paylod: response.data
      }
    })
}

export function saveSpecificFeedbacksToProd(feedbacks) {
  return axios.post(`${config.URL}/api/feedback/prod/specific/`, feedbacks)
    .then(response => {
      return {
        type: 'ADD_SPECIFIC_TO_PROD',
        paylod: response.data
      }
    })
}

export function saveMotivationFeedbacksToProd(feedbacks) {
  return axios.post(`${config.URL}/api/feedback/prod/motivation/`, feedbacks)
    .then(response => {
      return {
        type: 'ADD_MOTIVATION_TO_PROD',
        paylod: response.data
      }
    })
}

export function getMeasurements(){
  return axios.get(`${config.URL}/api/measurement`)
    .then(response => {
      return {
        type: 'GET_MEASURMENTS',
        paylod: response.data
      }
    })
}

export function getUsers(date) {
  return axios.get(`${config.URL}/api/user/all?date=${date}`)
    .then(response => {
      return {
        type: 'ALL_USERS',
        paylod: response.data
      }
    })
}

export function workoutsCompleted(date) {
  return axios.get(`${config.URL}/api/workout/workoutsCompleted?date=${date}`)
    .then(response => {
      return {
        type: 'WORKOUTS_COMPLETED',
        paylod: response.data
      }
    })
}

export function workoutsCompletedByUser(date) {
  return axios.get(`${config.URL}/api/workout/workoutsCompletedByUser?date=${date}`)
    .then(response => {
      return {
        type: 'WORKOUTS_COMPLETED_BY_USER',
        paylod: response.data
      }
    })
}

export function workoutsCompletedByWorkout() {
  return axios.get(`${config.URL}/api/workout/workoutsCompletedByWorkout`)
    .then(response => {
      return {
        type: 'WORKOUTS_COMPLETED_BY_WORKOUT',
        paylod: response.data
      }
    })
}

export function getWorkouts(query) {
  return axios.get(`${config.URL}/api/workout?search=${query}`)
  .then(response => {
    return {
      type: 'GET_WORKOUTS',
      paylod: response.data
    }
  })
}

export function saveWorkout({  _id,
trainer_name,
trainer_profile_picture,
trainer,
name,
level,
duration,
total_seconds,
calories,
intensity,
start_image,
summary_image,
description,
target_areas,
equipment,
video_path,
video_end_point,
video_aws_s3_key,
exercises,
interrupt_times}) {
  return axios.post(`${config.URL}/api/workout/`, {  _id,
    trainer_name,
    trainer_profile_picture,
    trainer,
    name,
    level,
    duration,
    total_seconds,
    calories,
    intensity,
    start_image,
    summary_image,
    description,
    target_areas,
    equipment,
    video_path,
    video_end_point,
    video_aws_s3_key,
    exercises,
    interrupt_times})
  .then(response => {
    return {
      type: 'SAVE_WORKOUT',
      paylod: response.data
    }
  })
}

export function deleteWorkouts(workouts){
  return axios.post(`${config.URL}/api/workout/deleteWorkouts`, { workouts })
  .then(response => {
    return {
      type: 'DELETE_WORKOUTS',
      paylod: response.data
    }
  })
}

export function getTempWorkouts(query) {
  return axios.get(`${config.URL}/api/workout/temp?search=${query}`)
  .then(response => {
    return {
      type: 'GET_TEMP_WORKOUTS',
      paylod: response.data
    }
  })
}

export function saveTempWorkout({  _id,
  trainer_name,
  trainer_profile_picture,
  trainer,
  name,
  level,
  duration,
  total_seconds,
  calories,
  intensity,
  start_image,
  summary_image,
  description,
  target_areas,
  equipment,
  video_path,
  video_end_point,
  video_aws_s3_key,
  exercises,
  interrupt_times}) {
    return axios.post(`${config.URL}/api/workout/temp/`, {  _id,
      trainer_name,
      trainer_profile_picture,
      trainer,
      name,
      level,
      duration,
      total_seconds,
      calories,
      intensity,
      start_image,
      summary_image,
      description,
      target_areas,
      equipment,
      video_path,
      video_end_point,
      video_aws_s3_key,
      exercises,
      interrupt_times})
    .then(response => {
      return {
        type: 'SAVE_TEMP_WORKOUT',
        paylod: response.data
      }
    })
}

export function deleteTempWorkouts(workouts) {
  return axios.post(`${config.URL}/api/workout/temp/deleteWorkouts/`, { workouts })
  .then(response => {
    return {
      type: 'DELETE_TEMP_WORKOUTS',
      paylod: response.data
    }
  })
}

export function saveWorkoutsToProd(workouts) {
  return axios.post(`${config.URL}/api/workout/prod/`,  workouts )
  .then(response => {
    return {
      type: 'SAVE_TO_PROD',
      paylod: response.data
    }
  })
}

export function getTrainers() {
  return axios.get(`${config.URL}/api/user/trainers/`)
  .then(response => {
    return {
      type: 'GET_TRAINERS',
      paylod: response.data
    }
  })
}

export function getExerciseMapping() {
  return axios.get(`${config.URL}/api/workout/exerciseMapping/`)
  .then(response => {
    return {
      type: 'GET_EXERCISE_MAPPING',
      paylod: response.data
    }
  })
}

export function saveExerciseMapping({_id, oldName, present_name,
name,
type,
front,
score,
bars,
skeleton,instructions, difficulty}) {
  console.log('o', oldName, present_name);
  return axios.post(`${config.URL}/api/workout/exerciseMapping/`, {_id, oldName, present_name,
    name,
    type,
    front,
    score,
    bars,
    skeleton,instructions, difficulty})
  .then(response => {
    return {
      type: 'SAVE_EXERCISE_MAPPING',
      paylod: response.data
    }
  })
}

export function planPurchased(date) {
  return axios.get(`${config.URL}/api/workout/planPurchased?date=${date}`)
  .then(response => {
    return {
      type: 'PLAN_PURCHASED',
      paylod: response.data
    }
  })
}

export function deleteExercisesMapping(ids) {
  return axios.post(`${config.URL}/api/workout/deleteExerciseMapping`, ids)
  .then(response => {
    return {
      type: 'DELETE_EXERCISE_MAPPING',
      paylod: response.data
    }
  })
}

export function deleteSpecificFeedback(ids) {
  return axios.post(`${config.URL}/api/feedback/specific/delete`, ids)
  .then(response => {
    return {
      type: 'DELETE_SPECIFIC_FEEDBACKS',
      paylod: response.data
    }
  })
}
export function saveExerciseMappingToProd(exercisesMapping) {
  return axios.post(`${config.URL}/api/workout/saveExerciseMappingToProd/`,  exercisesMapping )
  .then(response => {
    return {
      type: 'SAVE_EXERCISE_MAPPING_TO_PROD',
      paylod: response.data
    }
  })
}

export function addTrainer({ _id, email, details, status, type }){
  return axios.post(`${config.URL}/api/user/trainer`, { _id, email, details, status, type })
  .then(response => {
    return {
      type: 'ADD_TRAINER',
      paylod: response.data
    }
  })
  // const request = axios.post(`${config.URL}/api/user/trainer`, { _id, email, details, status, type })
  //   .then(response =>  response.data )

  //   return {
  //     type: 'ADD_TRAINER',
  //     paylod: request
  //   }
}

export function addTrainerToProd(trainers){
  const request = axios.post(`${config.URL}/api/user/prod/trainer`, trainers)
    .then(response =>  response.data )

    return {
      type: 'ADD_TRAINERS_TO_PROD',
      paylod: request
    }
}

export function getWorkoutsVideos() {
  return axios.get(`${config.URL}/api/workout/videos`)
  .then(response => {
    return {
      type: 'WORKOUT_VIDEOS',
      paylod: response.data
    }
  })
}

export function updateFreeUser(email){
  console.log("email", email);
  return axios.put(`${config.URL}/api/user/freeUser`,{ email })
  .then(response => {
    return {
      type: 'UPDATE_FREE_USER',
      paylod: response.data
    }
  })
  const request = axios.put(`${config.URL}/api/user/freeUser`, email)
    .then(response =>  response.data )

    return {
      type: 'UPDATE_FREE_USER',
      paylod: request
    }
}

export function getFreeUsers( ){
  return axios.get(`${config.URL}/api/user/freeUser`)
  .then(response => {
    return {
      type: 'GET_FREE_USERS',
      paylod: response.data
    }
  })
  const request = axios.get(`${config.URL}/api/user/freeUser`)
    .then(response =>  response.data )

    return {
      type: 'GET_FREE_USERS',
      paylod: request
    }
}

export function getSkills(query) {
  return axios.get(`${config.URL}/api/workout/skills?search=${query}`)
  .then(response => {
    return {
      type: 'GET_SKILLS',
      paylod: response.data
    }
  })
}

export function saveSkill({}) {
  return axios.post(`${config.URL}/api/workout/skills`,{})
  .then(response => {
    return {
      type: 'SAVE_SKILL',
      paylod: response.data
    }
  })
}